import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "appointmentList";
export const initialState = {
    upcomingAppointments: [],
    pastAppointments: [],
};

const ApptListReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        loadMoreUpcomingAppointments: (state, action) => ({
            ...state,
            upcomingAppointments: [...state.upcomingAppointments, ...action.payload]
        }),
        loadMorePastAppointments: (state, action) => ({
            ...state,
            pastAppointments: [...state.pastAppointments, ...action.payload]
        }),
        setPastAppointments: (state, action) => ({
            ...state,
            pastAppointments: action.payload,
        }),
        setUpcomingAppointments: (state, action) => ({
            ...state,
            upcomingAppointments: action.payload,
        }),
    }
});

export default ApptListReducer.reducer;
export const {
    loadMoreUpcomingAppointments,
    loadMorePastAppointments,
    setPastAppointments,
    setUpcomingAppointments,
} = ApptListReducer.actions;
